import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Review_contract_table from "./review_contract_table/Review_contract_table";

function Review_contract() {
  return (
    <>
      <section className="Imperiality Quality_Policy  ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Review Of Request , Tenders & Contract" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              Review of Requests, Tenders, and Contracts involves a detailed
              evaluation of all received inquiries, tender documents, and
              contractual terms to ensure compliance with requirements, clarity
              of scope, and risk identification before approval.
            </p>
          </div>
        </div>

        <div className="imperiality_table_div">
          <Review_contract_table />
        </div>
      </section>
    </>
  );
}

export default Review_contract;
